export const MSG = {
    // #region Api message
    'api.response.worng_format': '応答本文は正しい形式ではありません',
    'api.response.no_message': 'エラーメッセージの応答はありません',
    'api.response.server_error': 'サーバ接続に問題が発生しました。お手数ですが、もう一度アクセスし直してください。',
    'api.response.no_network': 'サーバ接続に問題が発生しました。お手数ですが、もう一度アクセスし直してください。',
    'api.response.authorization': '再度ログインして下さい。',
    'api.sign_in_success': 'サインインに成功しました。',
    // #endregion Api message

    // #region inform
    'inform.success.create': '作成は完了しました。',
    'inform.success.update': '編集は完了しました。',
    'inform.success.delete': '削除が完了しました。',
    'inform.success.import': 'CSVインポートが成功しました。',
    // #endregion

    // #region validate error message
    'error.required': '必須項目をご入力ください',
    'error.email_format': 'メールアドレスが正しくありません。',
    'error.email_confirm_not_match': '上記メールアドレスと一致しません。',
    'error.number_positive': '正数を入力してください。',
    'error.password_format': 'パスワードが正しくありません。',
    'error.confirm_password_not_match': '上記パスワードと一致しないため再入力をお願いします。',
    'error.promotion_code_not_match_format': '割引きクーポンコードが正しくありません。',
    'error.promotion_code_expires': '割引きクーポンコードの有効期限が切れています。',
    'error.password_format_detail': '８文字以上の半角英数字（１つ以上の大文字含める）',
    'error.format_latin_kanji': '漢字またはローマ字でご入力ください。',
    'error.format_hira_kata': 'フリガナでご入力ください。',
    'error.report.unsupported_format': 'ファイルの拡張子がサポートされていません。PDFのいずれかの拡張子で、ファイルをアップロードすることが可能。',
    'error.report.file_size': 'ファイルのアップロードに失敗しました。ファイルサイズが上限の100MBを超えています。再度お試しください。',
    // #endregion
    // user
    'confirm.confirm_active_user_title': '確認',
    'confirm.confirm_active_user_content': 'ステータスは有効にしてもよろしいですか。',
    'confirm.confirm_deactive_user_title': '確認',
    'confirm.confirm_deactive_user_content': 'ステータスは無効にしてもよろしいですか。',
    'confirm.confirm_delete_user_title': '確認',
    'confirm.confirm_delete_user_content':
        '削除してもよろしいですか？削除すれば、それに紐づく全 てのデータも削除されます',
    // student
    'confirm.confirm_delete_student_title': '確認',
    'confirm.confirm_delete_student_content':
        '削除してもよろしいですか？削除すれば、それに紐づく全てのデータも削除されます。',
    'confirm.confirm_active_student_title': '確認',
    'confirm.confirm_active_student_content': '選択した受講者を有効にしてよろしいですか。',
    'confirm.confirm_deactive_student_title': '確認',
    'confirm.confirm_deactive_student_content': '選択した受講者を無効にしてよろしいですか。',
    'confirm.confirm_download_training_center':
        'ダウンロードデータの中に、更新されていないダウンロード済みのデータが含まれます。ダウンロードを続けてよろしいですか。',
    'error.student_confirm_pharmacist_not_match_format': '上記「薬剤師名簿登録番号」 と一致しません。',
    'error.student_confirm_pharmacist_not_match_format_2': '「薬剤師名簿登録番号」 と一致しません。',
    'error.student_accept_file': 'システムは CSV ファイルインポートのみサポートする',
    'error.student_empty_csv_file': 'CSVファイルにある全ての項目は必須項目となります。',
    // #region promotion
    'confirm.confirm_delete_promotion_title': '確認',
    'confirm.confirm_delete_promotion_content': '削除すると、それに紐づく全てのデータも削除されます。',
    'confirm.confirm_active_promotion_title': '確認',
    'confirm.confirm_active_promotion_content': 'ステータスを「有効」にしてもよろしいですか？',
    'confirm.confirm_deactive_promotion_title': '確認',
    'confirm.confirm_deactive_promotion_content': 'ステータスを「無効」にしてもよろしいですか？',
    'error.max_length_amount': 'Number of characters longer than 9',
    // #endregion

    // #region faq
    'confirm.confirm_delete_faq_title': '確認',
    'confirm.confirm_delete_faq_content': '選択したよくある質問を削除してよろしいですか。',
    // #endregion

    // #region course
    'confirm.confirm_delete_course_title': '確認',
    'confirm.confirm_delete_course_content': '選択された講座は削除してもよろしいですか。',
    'confirm.confirm_active_course_title': '確認',
    'confirm.confirm_active_course_content': '選択された講座は有効にしてもよろしいですか。',
    'confirm.confirm_deactive_course_title': '確認',
    'confirm.confirm_deactive_course_content': '選択された講座は無効にしてもよろしいですか。',
    'confirm.confirm_publish_course_title': '確認',
    'confirm.confirm_publish_course_content':
        'この講座を公開しますが、よろしいですか。\n公開講座はシステム上のすべての受講者に表示されます。',
    'confirm.confirm_unpublish_course_title': '確認',
    'confirm.confirm_unpublish_course_content':
        'この講座を非公開にしますが、よろしいですか。\n非公開講座は受講中の受講者にのみ表示されます。他の受講者は本講座が見えません。',
    // #endregion

    // lecture
    'error.maximum_image_file': 'ファイルサイズの上限は10MBです。',
    'error.maximum_image_top_page': 'ファイルサイズの上限は500KBです。',
    'error.invalid_image':
        'ファイルの拡張子がサポートされていません。JPG(JPEG)、PNG、GIFのいずれかの拡張子で、ファイルをアップロードすることが可能。',
    'error.confirm_cancel_create': 'Are you sure you want to quit? All progress in this session will be lost.',
    'error.invalid_video':
        'ファイルの拡張子がサポートされていません。MP4の拡張子ファイルをアップロードする必要がございます。',
    'error.maximum_video_file': 'ファイル容量の上限は5 GBです。',
    'error.maximum_video_sample_file': 'ファイル容量の上限は10 GBです。',
    'error.maximum_video_top_page': 'ファイル容量の上限は５MBです。',
    'msg.upload_video_title': '動画アップロード中',
    'msg.upload_video_desc': 'アップロードが完了するまでブラウザは閉じないでください。',
    'confirm.delete_lecture': '削除してもよろしいですか？削除すると、それに紐づく全てのデータも削除されます。',
    'confirm.change_lecture_to_active': 'ステータスは有効にしてもよろしいですか。',
    'confirm.change_lecture_to_inactive': 'ステータスは無効にしてもよろしいですか。',
    'confirm.delete_message': 'このメッセージを削除してもよろしいですか?',

    // message
    'msg.send_to_all': 'すべてのユーザーに送信',

    // theme
    'error.theme_already_has_course': 'このテーマに講座が存在しているので削除はできません。',

    // payment
    'confirm.confirm_delete_purchase_content': 'この購入取引を削除してもよろしいですか。',
    'confirm.confirm_accept_cancel_purchase_content': 'このキャンセルリクエストを承認しますが、よろしいですか。',
    'confirm.confirm_reject_cancel_purchase_content': 'このキャンセルリクエストを拒否しますが、よろしいですか。',
    'confirm.confirm_export_invoice_purchase_content': '領収書を出力したい対象を選択してください。',

    // survey
    'error.survey.questions_required': '質問を１つ以上入力してください。',
    'error.survey.answers_required': '回答を１つ以上入力してください。',
    'error.survey.answers_unique': '同じ質問に重複する内容のオプションを作成することができません。',

    // information
    'error.information.thumbnail.unsupported_format':
        'ファイルの拡張子がサポートされていません。JPG(JPEG)、PNGのいずれかの拡張子で、ファイルをアップロードすることが可能。',
    'error.information.docs.unsupported_format':
        'ファイルの拡張子がサポートされていません。PDF、XLSX(XLS)、DOCX(DOC)のいずれかの拡張子で、ファイルをアップロードすることが可能。',
    'error.information.docs.file_size':
        'ファイルのアップロードに失敗しました。ファイルサイズが上限の50MBを超えています。再度お試しください。',
    'confirm.information.submit': 'この記事を保存してよろしいですか。',
    'confirm.information.delete': 'この記事を削除してよろしいですか。',
    'confirm.information.active': 'この記事を有効化してよろしいですか。',
    'confirm.information.inactive': 'この記事を無効化してよろしいですか。',

    // form validate
    'form_error_validate.required': '必須項目をご入力ください。',
    'form_error_validate.email': 'メールアドレスが正しくありません。'
};
